<app-breadcrumb [title]="'FAQs'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
            <a routerLink="/admin/faqs" class="btn btn-outline-primary">Cancel</a>
          </div>
        </div>
        <div class="card-body">
          <form [formGroup]="faqForm" (ngSubmit)="save()">
            <input type="hidden" formControlName="id">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="faqCategoryId">FAQ Category</label>
                  <select MyInput formControlName="faqCategoryId" class="form-select">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of faqCategories" value="{{ item.id }}">{{ item.name }}
                    </option>
                  </select>
                  <my-error controlName="faqCategoryId" errorKey="required">answer is required.</my-error>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="question">Question</label>
                  <textarea MyInput formControlName="question" class="form-control"></textarea>
                  <my-error controlName="question" errorKey="required">question is required.</my-error>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-3">
                  <label for="content">Answer</label>
                  <div class="col-md-12">
                    <angular-editor formControlName="answer" [config]="editorConfigOption"></angular-editor>
                  </div>
                  <my-error controlName="answer" errorKey="required">answer is required.</my-error>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn btn-primary rounded-0 mr-2" [disabled]="!faqForm.valid || loading" type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
              <button *ngIf="id" type="button" (click)="delete()" class="btn btn-danger rounded-0">Delete</button>
            </div>
          </form>

        </div>
      </div>

    </div>
  </div>
</div>